module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"id_col_name":"Name of the created id column","cwrw_column_name_overridden":"The column name chosen already exists, it will overwrite the column"},"fr":{"id_col_name":"Nom donné à la nouvelle colonne d\u0027identifiant","cwrw_column_name_overridden":"Le nom de colonne choisi existe déjà, la colonne d\u0027origine sera supprimée"}}')
  delete Component.options._Ctor
}
